import React from 'react';
import styled from '@emotion/styled';
import ReactModal from 'react-modal';
import { getBackgroundTheme, getTextColor } from '../../style';
import { CancelRounded } from '@material-ui/icons';
import { SvgIcon } from '@material-ui/core';
import { useDisableBodyScroll } from '../../hooks/useDisableBodyScroll';
import { IModalStyle } from './types';
import useMediaBreakpoints from '../../hooks/useMediaBreakpoints';

ReactModal.setAppElement('body');

const setModalStyle = (customStyle: IModalStyle, isMobile: boolean) => {
  const customOverlay = (customStyle.overlay && customStyle.overlay) || {};
  const customContent = (customStyle.content && customStyle.content) || {};

  const mobileOverlayStyle = {
    borderRadius: 10,
    height: '100%',
    width: '90%',
    padding: '0 10%',
    left: '-5%',
  };

  const overlayStyle = isMobile ? { ...customOverlay, ...mobileOverlayStyle } : customOverlay;
  const mobileCenterPosition = isMobile
    ? { top: '45%', transform: 'translate(-50%,-50%)' }
    : { top: 82, transform: 'translate(-50%,0)' };

  return {
    overlay: {
      zIndex: 10001,
      backgroundColor: 'rgba(0,0,0,0.65)',
      ...overlayStyle,
    },
    content: {
      margin: 'unset',
      outline: 'none',
      left: '50%',
      ...mobileCenterPosition,
      bottom: 'initial',
      maxHeight: '80vh',
      overflow: 'auto',
      ':focus': {
        outline: 'none',
      },
      padding: 0,
      position: 'relative',
      borderRadius: 10,
      backgroundColor: getBackgroundTheme().block,
      ...customContent,
      ...getTextColor().DARK,
    },
  };
};

const Content = styled('div')({
  position: 'relative',
  padding: 22,
});

const CloseBtn = styled('button')({
  appearance: 'none',
  border: 'none',
  background: 'none',
  width: 48,
  height: 48,
  position: 'absolute',
  top: 0,
  right: 0,
});

const closeButton = {
  fontSize: 24,
  color: '#8F8F8F',
};

const GalleryModal = (props: any): any => {
  const {
    closeOnOverlayClick,
    onClose,
    hideClose,
    customStyle,
    children,
    isOpen,
    customContentStyle,
    customCloseBtnStyle,
    forceDisableBodyScroll = false,
    ...rest
  } = props;

  useDisableBodyScroll(forceDisableBodyScroll ? true : isOpen);
  const { isMobile } = useMediaBreakpoints();

  return (
    // @ts-expect-error To be fix in https://reflexmedia.atlassian.net/browse/WYP-16389
    <ReactModal
      style={setModalStyle(customStyle, isMobile)}
      ariaHideApp={false}
      shouldCloseOnOverlayClick={closeOnOverlayClick}
      onRequestClose={onClose}
      isOpen={isOpen}
      className="gallery-modal"
      {...rest}
    >
      <Content style={customContentStyle}>
        {!hideClose && (
          <CloseBtn data-test-id={`confirm-upload-close`} onClick={onClose} style={customCloseBtnStyle}>
            <SvgIcon component={CancelRounded} style={closeButton} />
          </CloseBtn>
        )}
        {children}
      </Content>
    </ReactModal>
  );
};

GalleryModal.defaultProps = {
  closeOnOverlayClick: false,
  customStyle: {},
};

export default GalleryModal;
